document.addEventListener('DOMContentLoaded', function () {

  function enforceLimit() {
    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        if (cart.item_count > 2) {

          const updates = {};

          // Zero out everything
          cart.items.forEach(item => {
            updates[item.key] = 0;
          });

          // Restore only the first 2
          cart.items.slice(0, 2).forEach(item => {
            updates[item.key] = item.quantity;
          });

          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates })
          }).then(() => {
            alert("You can only add up to 2 items per order.");
          });

        }
      });
  }

  // 🚫 REMOVE AUTO RUN
  // enforceLimit();

  document.body.addEventListener("click", function (e) {

    // Add to cart buttons
    if (e.target.closest(".product-buy-buttons--primary")) {
      setTimeout(enforceLimit, 600);
    }

    // Quick add
    if (e.target.closest("product-quick-add") || e.target.closest("[data-product-add]")) {
      setTimeout(enforceLimit, 600);
    }

    // Qty update
    if (e.target.closest(".quantity-selector--plus") || e.target.closest(".quantity-selector--minus")) {
      setTimeout(enforceLimit, 600);
    }

    // Remove button
    if (e.target.closest(".quantity-selector--remove")) {
      setTimeout(enforceLimit, 600);
    }

  });

});